import { type DomainAccessControlConfig } from '../../../utils/domain/accessControl'
import { Permission } from '../../../access-control/permissions'

export const enterpriseStatusPageAccessControl: DomainAccessControlConfig = [
  { permissions: [Permission.EnterpriseStatusPageView] },
  { permissions: [Permission.RetailerContactManagementView] },
]
